// src/router/authGuards.jsx
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

// src/router/authGuards.jsx
const getToken = () =>
  localStorage.getItem("authToken") || localStorage.getItem("demo-token");

export const isAuthenticated = () => !!getToken();

export function RequireAuth() {
  const location = useLocation();
  return isAuthenticated()
    ? <Outlet />
    : <Navigate to="/signin" replace state={{ from: location }} />;
}

export function PublicOnly() {
  return isAuthenticated()
    ? <Navigate to="/index" replace />
    : <Outlet />;
}
